import { Fragment } from "react";
import { getEmojiByKey } from "./microsite/icons";

type Props = {
  id: string;
  size?: string;
  set?: string;
};

const Emoji = ({ id, size, set = "twitter" }: Props) => {
  const found = getEmojiByKey(id);
  if (found === null) {
    return <Fragment />;
  }
  const { emoji, skin } = found;
  const emojiSkin = emoji.skins[parseInt(skin) - 1] || emoji.skins[0];

  const imageSrc = `https://cdn.jsdelivr.net/npm/emoji-datasource-${set}@14.0.0/img/${set}/64/${emojiSkin.unified}.png`;

  return (
    <img
      style={{
        height: size || "1em",
        width: "auto",
      }}
      className="object-contain"
      alt={emojiSkin.native || emojiSkin.shortcodes}
      src={imageSrc}
    />
  );
};

export default Emoji;
